<template>
  <div class="occupancy-container">
    <div>
      Pokój {{ index + 1 }}
      <button
        v-if="occupancy.$root.totalRooms.$model > 1"
        type="button"
        class="btn btn-default btn-xs remove"
        @click.stop="remove"
      >Usuń</button>
    </div>

    <WInput class="amount" :model="occupancy.numberOfAdults" />

    <WInput class="amount" :model="occupancy.numberOfChildren3" />

    <WInput class="amount" :model="occupancy.numberOfChildren12" />
  </div>
</template>

<script>
import WInput from '@witkac/bootstrap4-components/src/components/input';

export default {
  components: { WInput },
  props: {
    index: { type: Number, required: true },
    occupancy: { type: Object }
  },
  methods: {
    remove() {
      this.$emit('remove', this.index);
    }
  }
};
</script>

<style lang="scss">
.occupancy-container {
  .amount {
    padding-right: 0;
    & > div::after {
      display: block;
      clear: both;
      content: '';
    }
    label {
      width: auto !important;
      padding-top: 5px;
    }
    .form-control {
      width: 40px;
      float: right;
      padding: 1px 5px 1px 1px !important;
      margin: 2px 3px 5px 3px !important;
      height: auto !important;
      border-color: #984438;
    }
  }
  .remove {
    color: white;
    float: right;
    padding: 0 4px;

    &:hover {
      color: white;
    }
  }
}
</style>
